/* Copyright (c) 2020-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import dayjs from "dayjs";
import { Cell } from "react-table";
import { format } from "timeago.js";
import { Button, FlexContainer, SVGIcon } from "@nordcloud/gnui";
import { CustomCell } from "~/components/Tables/Cells";
import { dateFormat } from "~/constants";
import { truncateString } from "~/tools";

type ExternalIntegrations = {
  id: string;
  name: string;
  createdAt: string;
  lastSync: string;
};

const TRUNCATE_LENGTH = 50;

type Props = {
  onDelete: (id: string, name: string) => void;
};

export function ExternalIntegrationsColumns({ onDelete }: Props) {
  return [
    {
      accessor: "icon",
      disableSortBy: true,
      width: "5%",
      Cell: () => (
        <FlexContainer justifyContent="center">
          <SVGIcon name="externalIntegration" size="lg" />
        </FlexContainer>
      ),
    },
    {
      Header: "Integration Name",
      accessor: "integrationName",
      width: "40%",
      disableSortBy: true,
      Cell: ({ row }: Cell<ExternalIntegrations>) => (
        <CustomCell
          url={`/external-integrations/${row.original.id}`}
          name={
            row.original.name.length > TRUNCATE_LENGTH
              ? truncateString(row.original.name, TRUNCATE_LENGTH)
              : row.original.name
          }
        />
      ),
    },
    {
      Header: "Creation Date",
      accessor: "creationDate",
      width: "25%",
      disableSortBy: true,
      Cell: ({ row }: Cell<ExternalIntegrations>) => (
        <CustomCell
          name={dayjs(row.original.createdAt).format(dateFormat.dayMonthYear)}
        />
      ),
    },
    {
      Header: "Last Sync",
      accessor: "lastSync",
      width: "28%",
      disableSortBy: true,
      Cell: ({ row }: Cell<ExternalIntegrations>) => (
        <CustomCell
          name={row.original?.lastSync ? format(row.original.lastSync) : "n/a"}
        />
      ),
    },
    {
      Header: "",
      accessor: "action",
      width: "2%",
      disableSortBy: true,
      Cell: ({ row }: Cell<ExternalIntegrations>) => (
        <Button
          severity="low"
          icon="trash"
          onClick={() => onDelete(row.original.id, row.original.name)}
        />
      ),
    },
  ];
}
